export const defaultTransitionDuration = "0.3s"
export const headerHeight = 60
